export function createArrayOf(length: number, start = 1) {
    return Array.from(Array(length).keys(), (x) => x + start);
}
